module.exports = __webpack_public_path__ + "static/img/cs-24-kaka.c7cc2df1.svg";